import MigrationPage from './MigrationPage';
export default MigrationPage;